/** Duty ping interval — stored as seconds, edited in minutes. */

export const PING_INTERVAL_PRESETS = [
  { label: "1 min", seconds: 60 },
  { label: "2 min", seconds: 120 },
  { label: "5 min", seconds: 300 },
  { label: "10 min", seconds: 600 },
  { label: "15 min", seconds: 900 },
  { label: "30 min", seconds: 1800 },
] as const;

export function secondsToMinutes(seconds: number): number {
  return Math.round(seconds / 60);
}

export function minutesToSeconds(minutes: number): number {
  return minutes * 60;
}

export function formatPingInterval(seconds: number): string {
  const minutes = secondsToMinutes(seconds);
  return minutes === 1 ? "Every 1 minute" : `Every ${minutes} minutes`;
}
